export { default } from './IndustryLinks';
export type { Props, Props as IndustryLinksProps } from './IndustryLinks';
